import { default as dayjs } from 'dayjs'
import quarterOfYear from 'dayjs/plugin/quarterOfYear'
dayjs.extend(quarterOfYear)

export const formatToMonthAndYear = (dateToFormat: string): string => {
  try {
    return dayjs(dateToFormat).format('MMM YYYY')
  } catch {
    return ''
  }
}

export const formatToFullDate = (dateToFormat: string): string => {
  try {
    const day = dayjs(dateToFormat).format('D')
    const rest = dayjs(dateToFormat).format('MMM YYYY')
    return `${day}${nth(day)} ${rest}`
  } catch {
    return ''
  }
}

function nth(n) {
  return ['st', 'nd', 'rd'][((((n + 90) % 100) - 10) % 10) - 1] || 'th'
}

export const getDateQuickPickOptions = () => {
  const now = dayjs()
  const format = 'YYYY-MM-DD'
  const endDate = now.format(format)

  const quarterStart = now
    .subtract(1, 'quarter')
    .startOf('quarter')
    .format(format)
  const quarterEnd = now.subtract(1, 'quarter').endOf('quarter').format(format)

  const options = [
    {
      label: 'Yesterday',
      value: now.subtract(1, 'day').format(format),
      endDate,
    },
    {
      label: 'Last Week',
      value: now.subtract(1, 'week').format(format),
      endDate,
    },
    {
      label: 'Last Month',
      value: now.subtract(1, 'month').format(format),
      endDate,
    },
    {
      label: 'Last Quarter',
      value: quarterStart,
      endDate: quarterEnd,
    },
    {
      label: 'Last Year',
      value: now.subtract(1, 'year').format(format),
      endDate,
    },
    {
      label: 'All time',
      value: null,
      endDate: null,
    },
  ]

  return options
}

export const getPreviousPeriod = (
  dateFrom: string = null,
  dateTo: string = null,
) => {
  const nowInstance = dayjs()
  const format = 'YYYY-MM-DD'

  if (!dateFrom || !dateTo) {
    return {
      dateFrom: nowInstance.subtract(2, 'year').format(format),
      dateTo: nowInstance.subtract(1, 'year').format(format),
    }
  }

  const newDateTo = dayjs(dateFrom)

  const diff = newDateTo.diff(dayjs(dateTo), 'days')

  return {
    dateFrom: newDateTo.subtract(Math.abs(diff), 'days').format(format),
    dateTo: newDateTo.format(format),
  }
}

export const getChartTooltipDate = (date: any) => {
  try {
    const newDate = dayjs(date)
    const format = 'DD/MM/YYYY'
    return newDate.format(format)
  } catch {
    return ''
  }
}

export const filtersDateRange = (
  dateFrom: string = null,
  dateTo: string = null,
) => {
  const format = 'DD/MM/YYYY'

  if (!dateFrom || !dateTo) {
    return {
      dateFrom: null,
      dateTo: null,
    }
  }

  const newDateFrom = dayjs(dateFrom)
  const newDateTo = dayjs(dateTo)

  return {
    dateFrom: newDateFrom.format(format),
    dateTo: newDateTo.format(format),
  }
}

export const formatDateDefault = (date: string) => {
  try {
    const format = 'DD/MM/YYYY'
    const newDate = dayjs(date)
    return newDate.format(format)
  } catch {
    return date
  }
}
